module.exports = __webpack_public_path__ + "img/dagou.c4173c15.png";